"use strict";

if (document.getElementById("app_document")) {
  var vueEditDoc = new Vue({
    delimiters: ['[[', ']]'],
    el: '#app_document',
    data: {
      document: [],
      attachments: [],
      docImage: ''
    },
    mounted: function mounted() {
      $.ajaxSetup({
        traditional: true
      });
    },
    methods: {
      getDocument: function getDocument(id) {
        var urlApi = '/api/v1/documents/' + id;
        $.ajax({
          url: urlApi,
          method: 'GET',
          beforeSend: function beforeSend(request) {
            return request.setRequestHeader("Accept-Language", languageCode);
          },
          success: function success(response) {
            $('.js-add-attachment-doc').removeClass('disabled');
            $('.js-add-attachment-doc').openModal();
            CKEDITOR.replace('content', {
              customConfig: confCKeditor
            });

            if (response.image) {
              vueEditDoc.docImage = response.image_obj.thumbnail_url;
            }

            vueEditDoc.document = response;
            setTimeout(function () {
              vueEditDoc.deleteDocument();
              vueEditDoc.getAttachments();
              $('.js-groups-checkboxes').initGroupsDocs();
            }, 500);
          },
          error: function error(_error) {
            console.log(_error);
          }
        });
      },
      deleteDocument: function deleteDocument() {
        var deleteBtn = $('.js-delete-document');
        deleteBtn.on('click', function () {
          var id = $(this).data('id'),
              urlDocs = $(this).data('url');
          $.ajax({
            url: '/api/v1/documents/' + id,
            type: 'DELETE',
            success: function success(response) {
              window.location.href = urlDocs;
            },
            error: function error(_error2) {
              console.log(_error2);
            }
          });
        });
      },
      getAttachments: function getAttachments() {
        var urlApi = '/api/v1/attachments?editing=1&rubric=3&object_id=' + $('.js-document').data('id');
        $.ajax({
          url: urlApi,
          method: 'GET',
          beforeSend: function beforeSend(request) {
            return request.setRequestHeader("Accept-Language", languageCode);
          },
          success: function success(response) {
            vueEditDoc.attachments = response.results;
            setTimeout(function () {
              vueEditDoc.deleteAttachment();
            }, 500);
          },
          error: function error(_error3) {
            console.log(_error3);
          }
        });
      },
      allowAttachments: function allowAttachments() {
        var inputs = $('[data-error]').find('input:not(.input-modal)');
        validate();
        inputs.on('change input keyup', validate);

        function validate() {
          var inputLength = 0;
          inputs.each(function () {
            $(this).val() == '' ? inputLength-- : inputLength++;
          });
          inputLength >= inputs.length ? notEmpty() : isEmpty();
        }

        function notEmpty() {
          $('.js-add-attachment-doc').removeClass('disabled');
          $('.js-add-attachment-doc').openModal();
        }

        function isEmpty() {
          $('.js-add-attachment-doc').addClass('disabled');
        }
      },
      typeAttachment: function typeAttachment() {
        var select = $('.js-form-upload').find('.js-select');
        select.on('change', function () {
          if ($(this).find('option:selected').data('slug') !== 'videos' && $(this).find('option:selected').data('slug') !== 'video') {
            var $target = $('[data-tab="tab_1"]'),
                $currentItem = $('.js-tab-toggle[data-target="1"]');
            $('.js-tab-toggle[data-target="2"]').removeClass('active').hide();
            $currentItem.addClass('active').show();
            $('.js-tab-item').find('input').attr('required', false);
            $target.find('input').attr('required', true);
            setTimeout(function () {
              $('.js-tab-item').hide();
              $target.show();
              setTimeout(function () {
                $target.addClass('left');
                $target.addClass('active').removeClass('left right');
              }, 50);
            }, 150);
            $('.js-underline').css({
              'width': $currentItem.width()
            });
          } else {
            var $target = $('[data-tab="tab_2"]'),
                $currentItem = $('.js-tab-toggle[data-target="2"]');
            $('.js-tab-item').find('input').attr('required', false);
            $target.find('input').attr('required', true);
            $currentItem.addClass('active').show();
            $('.js-tab-toggle[data-target="1"]').removeClass('active').hide();
            $currentItem.css({
              'padding-left': 0
            });
            $('.js-underline').css({
              'width': $currentItem.width(),
              'left': $currentItem.position().left
            });
            setTimeout(function () {
              $('.js-tab-item').hide();
              $target.show();
              setTimeout(function () {
                $target.addClass('right');
                $target.addClass('active').removeClass('left right');
              }, 50);
            }, 150);
          }
        });
      },
      addAttachment: function addAttachment() {
        var input = $('#uploadAttachment').find('.js-attachment-input'),
            filename = $('#uploadAttachment').find('.js-filename'),
            fileData = '';
        input.on('change', function (e) {
          var fileName = e.target.files[0].name;
          fileData = $(this)[0].files[0];
          filename.text(fileName);
        });
        $('.js-form-upload').on('submit', function (e) {
          var that = this;
          e.preventDefault();

          if (!that.classList.contains('form-is-updating')) {
            that.classList.add('form-is-updating');
            var formData = new FormData($(this)[0]); // Téléchargement

            if ($(this).find('.js-tab-toggle.active').attr('data-target') == 1) {
              formData.append('title', $('#attachment_title').val());
              formData.append('file', $('#uploadAttachment').find('.js-attachment-input')[0].files[0]);
            } // Lien url


            if ($(this).find('.js-tab-toggle.active').attr('data-target') == 2) {
              formData.append('title', $('#attachment_video_title').val());
              formData.append('video_id', $('#attachment_video_url').val());
            }

            formData.append('rubric', 3);
            formData.append('file_type', parseInt($('#type_attachment').find('option:selected').data('id')));
            formData.append('content_type', parseInt($('.js-document').data('content-type')));
            formData.append('video_id', $('#attachment_video_url').val());

            if ($(this).hasClass('js-form-create-upload')) {
              var groupsArr = [];
              $('.js-groups-checkboxes').each(function () {
                if ($(this).prop('checked') || $(this).prop('disabled')) {
                  groupsArr.push(parseInt($(this).val()));
                }
              });
              var dataToSend = {
                "title": $('#title').val(),
                "published_date": $('#published_date').val(),
                "content": CKEDITOR.instances['content'].getData(),
                "is_published": $('#publish').prop('checked'),
                "author": parseInt($('#author').val()),
                "image": $('.js-preview').data('image-id'),
                "groups": groupsArr
              };
              $.ajax({
                url: '/api/v1/documents',
                type: 'POST',
                data: JSON.stringify(dataToSend),
                cache: false,
                contentType: 'application/json',
                processData: false,
                success: function success(response) {
                  formData.append('object_id', response.id);
                  $('.js-form-document').unbind('submit');
                  $('.js-form-document').removeClass('js-create-document');
                  $('.js-form-upload').removeClass('js-form-create-upload');
                  $('.js-form-document').addClass('js-redirect');
                  $('.js-document').attr('data-id', response.id);
                  that.classList.remove('form-is-updating');
                  setTimeout(function () {
                    $('.js-form-document').updateDocument(response.id);
                  }, 500);
                },
                error: function error(_error4) {
                  console.log(_error4);
                  var errors = _error4.responseJSON;
                  new Alert().error();

                  for (_error4 in errors) {
                    $('[data-error="' + _error4 + '"]').addClass('has-error');
                  }
                }
              });
            } else {
              formData.append('object_id', parseInt($('.js-document').attr('data-id')));
            }

            setTimeout(function () {
              $.ajax({
                url: '/api/v1/attachments',
                type: 'POST',
                data: formData,
                contentType: false,
                processData: false,
                success: function success(response) {
                  that.classList.remove('form-is-updating');
                  $('#uploadAttachment').removeClass('is-open');
                  $('.js-modal-error').hide();
                  var wrapper = $('.js-attachments-wrapper');
                  var div = '<div class="col-lg-6">' + '<div class="attachment-edit">' + '<p>' + response.title + '</p>' + '<div class="close js-delete-attachment" data-id="' + response.id + '"><img src="/static/svg/private/close-icon.svg" title="Delete"></div>' + '</div>' + '</div>';
                  wrapper.append(div);
                  vueEditDoc.deleteAttachment();
                  new Alert().success(); // $(".js-form-upload").unbind('submit');
                  // return false;
                },
                error: function error(_error5) {
                  var errors = _error5.responseJSON;
                  var errorText = _error5.responseJSON.file[0];

                  for (_error5 in errors) {
                    $('.js-form-upload').find('.js-tab-item.active').find('[data-error="' + _error5 + '"]').addClass('has-error');
                  }

                  console.log(errorText);
                  $('.js-modal-error').text(errorText);
                  $('.js-modal-error').show();
                }
              });
            }, 1000); // $(".js-form-upload").unbind('submit');
            // return false;
          }
        });
      },
      deleteAttachment: function deleteAttachment() {
        var deleteBtn = $('.js-delete-attachment');
        deleteBtn.on('click', function () {
          var id = $(this).data('id');
          var attachment = $(this).parent().parent();
          $.ajax({
            url: '/api/v1/attachments/' + id,
            type: 'DELETE',
            success: function success(response) {
              attachment.remove();
            },
            error: function error(_error6) {
              console.log(_error6);
            }
          });
        });
      }
    }
  });
  var postID = $('.js-document').data('id');

  if (!$('.js-form-document').hasClass('js-create-document')) {
    vueEditDoc.getDocument(postID);
  } else {
    vueEditDoc.allowAttachments();
    CKEDITOR.replace('content', {
      customConfig: confCKeditor
    });
  }
}

(function ($) {
  $.fn.updateDocument = function (id_document) {
    $('#document_image').on('change', function () {
      var formData = new FormData($('.js-form-document'));
      formData.append('image', $(this)[0].files[0]);
      formData.append('attachment', $(this)[0].files[0]);
      formData.append("csrfmiddlewaretoken", $('[name="csrfmiddlewaretoken"]').val());
      $.ajax({
        url: '/api/v1/medias',
        type: 'POST',
        data: formData,
        cache: false,
        contentType: false,
        processData: false,
        beforeSend: function beforeSend() {
          $('.js-loader').show();
          $('.js-loader').addClass('animated');
        },
        success: function success(response) {
          console.log(response);
          $('.js-preview').css({
            'background-image': 'url(' + response.large_url + ')'
          });
          $('.js-preview').attr('data-image-id', response.id);
          $('.js-preview').attr('data-image', response.image);
          $('.js-loader').hide();
          $('.js-loader').removeClass('animated');
          new Alert().success();
        },
        error: function error(_error7) {
          console.log(_error7);
          $('.js-loader').hide();
          $('.js-loader').removeClass('animated');
          new Alert().warning();
        }
      });
    });
    var that = $(this);
    that.on('submit', function (e) {
      console.log('submit');
      e.preventDefault();

      if ($(this).hasClass('js-create-document')) {
        var urlApi = '/api/v1/documents';
        var method = 'POST';
      } else {
        var urlApi = '/api/v1/documents/' + id_document;
        var method = 'PUT';
      }

      var groupsArr = [];
      $('.js-groups-checkboxes').each(function () {
        if ($(this).prop('checked') || $(this).prop('disabled')) {
          groupsArr.push(parseInt($(this).val()));
        }
      });
      var dataToSend = {
        "title": $('#title').val(),
        "published_date": $('#published_date').val(),
        "content": CKEDITOR.instances['content'].getData(),
        "is_published": $('#publish').prop('checked'),
        "author": parseInt($('#author').val()),
        "image": $('.js-preview').data('image-id'),
        "groups": groupsArr
      };
      $.ajax({
        url: urlApi,
        type: method,
        data: JSON.stringify(dataToSend),
        cache: false,
        contentType: 'application/json',
        processData: false,
        success: function success(response) {
          $('.js-notification').addClass('show');

          if (that.hasClass('js-redirect')) {
            that.find('button[type="submit"]').attr('disabled', true);
            that.find('button[type="submit"]').addClass('disabled');
          }

          setTimeout(function () {
            $('.js-notification').removeClass('show');

            if (that.hasClass('js-redirect')) {
              window.location.replace(that.data('success'));
            } else {
              that.find('button[type="submit"]').attr('disabled', false);
              that.find('button[type="submit"]').removeClass('disabled');
            }
          }, 1500);
        },
        error: function error(_error8) {
          console.log(_error8);
          var errors = _error8.responseJSON;

          for (_error8 in errors) {
            $('[data-error="' + _error8 + '"]').addClass('has-error');
          }
        }
      }); // $('.js-form-document').unbind('submit');
      // return false;
    });
  };
})(jQuery);

(function ($) {
  $.fn.initGroupsDocs = function () {
    var groups = $('.js-docs-groups');
    var arrGroups = [];
    groups.each(function () {
      arrGroups.push(parseInt($(this).attr('id')));
    });
    $('.js-groups-checkboxes').each(function () {
      if ($(this).prop('disabled') == false) {
        for (var i = 0; i < arrGroups.length; i++) {
          if ($(this).attr('id') == arrGroups[i]) {
            $(this).prop('checked', true);
          }
        }
      }
    });
  };
})(jQuery);

$(function () {
  if ($('.js-form-document').length) {
    $('.js-form-document').updateDocument($('.js-document').data('id'));
  }

  if ($('.js-add-attachment-doc').length) {
    $('.js-add-attachment-doc').on('click', function () {
      vueEditDoc.addAttachment();
      vueEditDoc.typeAttachment();
    });
  }
});